import { match } from 'ts-pattern';

import { SimplifiedTransactionStatus } from '@/types/transaction';

export interface StatusSpecs {
  readonly label: string;
  readonly backgroundColor: string;
  readonly color: string;
}

type StatusSpec = {
  readonly label: SimplifiedTransactionStatus;
  readonly color: string;
  readonly backgroundColor: string;
};

const successStatus = [SimplifiedTransactionStatus.COMPLETED];

const pendingStatus = [SimplifiedTransactionStatus.IN_PROGRESS];

const failedStatus = [SimplifiedTransactionStatus.FAILED];

const expiredStatus = [SimplifiedTransactionStatus.EXPIRED];

export const statusSpecs = (status: SimplifiedTransactionStatus): StatusSpec =>
  match(status)
    .when(
      isSuccessStatus,
      (): StatusSpec => ({
        label: status,
        backgroundColor: 'status.completed.background',
        color: 'status.completed.foreground',
      }),
    )
    .when(
      isPendingStatus,
      (): StatusSpec => ({
        label: status,
        backgroundColor: 'status.pending.background',
        color: 'status.pending.foreground',
      }),
    )
    .when(
      isExpiredStatus,
      (): StatusSpec => ({
        label: status,
        backgroundColor: 'custom.LightBlue',
        color: 'status.expired.foreground',
      }),
    )
    .when(
      isFailedStatus,
      (): StatusSpec => ({
        label: status,
        backgroundColor: 'status.failed.background',
        color: 'status.failed.foreground',
      }),
    )
    .otherwise(
      (): StatusSpec => ({
        label: status,
        color: 'inherit',
        backgroundColor: 'inherit',
      }),
    );

const isExpiredStatus = (status: SimplifiedTransactionStatus): boolean =>
  expiredStatus.includes(status);

const isSuccessStatus = (status: SimplifiedTransactionStatus): boolean =>
  successStatus.includes(status);

const isPendingStatus = (status: SimplifiedTransactionStatus): boolean =>
  pendingStatus.includes(status);

const isFailedStatus = (status: SimplifiedTransactionStatus): boolean =>
  failedStatus.includes(status);
